module.exports = __webpack_public_path__ + "img/865-a68c82.png";